module.exports = __webpack_public_path__ + "static/media/minivan_purple.3e2c4aca.svg";